module.exports = __webpack_public_path__ + "img/電気回路_2_2.102afbb8.png";